import React, { useState } from 'react';
import { Button, Form, Input, Alert, Card, Typography } from 'antd';
import { Link } from 'react-router-dom';

const { Title, Text } = Typography;

interface RegenerateFormProps {
  onSubmit?: (values: { email: string }) => Promise<void>;
  loading?: boolean;
  error?: string;
  success?: string;
}

export default function RegenerateForm({
  onSubmit,
  loading = false,
  error,
  success,
}: RegenerateFormProps) {
  const [form] = Form.useForm();

  const handleSubmit = async (values: { email: string }) => {
    if (onSubmit) {
      await onSubmit(values);
    }
  };

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
      }}
    >
      <Card
        style={{
          width: '100%',
          maxWidth: 400,
          padding: '2rem',
          boxShadow: '0 10px 30px rgba(0,0,0,0.3)',
        }}
      >
        <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
          <Title level={2} style={{ color: '#93c90e', marginBottom: '0.5rem' }}>
            Resend Activation Email
          </Title>
          <Text type="secondary">Enter your email address to receive a new activation link</Text>
        </div>

        {error && (
          <Alert
            message="Error"
            description={error}
            type="error"
            style={{ marginBottom: '1rem' }}
            showIcon
          />
        )}

        {success && (
          <Alert
            message="Email Sent"
            description={success}
            type="success"
            style={{ marginBottom: '1rem' }}
            showIcon
          />
        )}

        <Form form={form} layout="vertical" onFinish={handleSubmit} size="large">
          <Form.Item
            name="email"
            label="Email Address"
            rules={[
              { required: true, message: 'Please enter your email address' },
              { type: 'email', message: 'Please enter a valid email address' },
            ]}
          >
            <Input
              placeholder="Enter your email address"
              autoComplete="email"
              style={{ borderRadius: '6px' }}
            />
          </Form.Item>

          <Form.Item style={{ marginBottom: '1rem' }}>
            <Button
              type="primary"
              htmlType="submit"
              loading={loading}
              style={{
                width: '100%',
                height: '45px',
                borderRadius: '6px',
                backgroundColor: '#93c90e',
                borderColor: '#93c90e',
              }}
            >
              {loading ? 'Sending...' : 'Send Activation Email'}
            </Button>
          </Form.Item>

          <div style={{ textAlign: 'center' }}>
            <Text type="secondary">
              Remember your password?{' '}
              <Link to="/login" style={{ color: '#93c90e' }}>
                Sign In
              </Link>
            </Text>
          </div>
        </Form>
      </Card>
    </div>
  );
}
